import { FormattedMessage } from 'react-intl'
import Text from 'components/shared/Text'
import Info from 'components/shared/Info'
import { darkMode } from 'styles/theme'
import { BLACK_WEEKEND_REGULATIONS_LINK } from 'constants/links'

const PromoInfo = () => (
    <Text variant="bodySmall" color="grayscale_400">
        <FormattedMessage
            id="promo.black_weekend.unlimited_promo_initial_info"
            defaultMessage="W Black Weekend kupisz kartę Unlimited o <strong>10% taniej</strong>! Promocja obowiązuje do <strong>02.12.24 do godz. 23:59.</strong> Użyj kodu <strong>BLACKWEEKEND</strong> i baw się w Suntago cały rok! "
            description="Keep the html tags in the translation"
            values={{
                strong: (chunks: string[]) => (
                    <>
                        <Text as="span" variant="bodySmall" color="primary_500">
                            {chunks}
                        </Text>
                    </>
                ),
            }}
        />
    </Text>
)

const RegulationsLink = () => (
    <Text
        as="a"
        href={BLACK_WEEKEND_REGULATIONS_LINK}
        target="_blank"
        variant="bodySmall"
        isUnderlined
        color="grayscale_400"
    >
        <FormattedMessage
            id="promo.black_weekend.regulations_link"
            defaultMessage="Regulamin promocji"
        />
    </Text>
)

const BlackWeekendUnlimitedInitialInfo = () => (
    <Info color="info" hasNoBackground hasBorder theme={darkMode}>
        <PromoInfo />
        <RegulationsLink />
    </Info>
)

export default BlackWeekendUnlimitedInitialInfo
